// extracted by mini-css-extract-plugin
export default {"main":"styles_main__cyZVP","spin":"styles_spin__awikA"};